import React, { useCallback } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import ActionText from '../../ActionText'

import useStyles from './styles'

const MinimisedSectionHeader = ({ title, onDelete, deleteBtnText = 'Remove', className, titleClassName, children }) => {
  const classes = useStyles()

  const handleDelete = useCallback(
    e => {
      e.stopPropagation()
      onDelete && onDelete()
    },
    [onDelete]
  )

  return (
    <div className={classnames(classes.header, className)}>
      <h3 className={classnames(classes.headerTitle, titleClassName)}>{title}</h3>
      {onDelete && (
        <ActionText className={classes.removeSectionBtn} onClick={handleDelete}>
          {deleteBtnText}
        </ActionText>
      )}
      {children && children}
    </div>
  )
}

MinimisedSectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
  deleteBtnText: PropTypes.string,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  children: PropTypes.node
}

export default MinimisedSectionHeader
